import React from "react";
import ReactPlayer from "react-player";
import { PandaVideo } from "../../../PandaVideo";
import { VideoWrapper } from "./VideoPlayerStyled";
import { IPandaEvent } from "../../../../hooks/useVideoPlayer";

interface VideoPlayerProps {
	videoUrl: string;
	playing: boolean;
	playerRef: React.RefObject<any>;
	startTime: number;
	onPlay: (isPanda: boolean, pandaEvent?: IPandaEvent) => void;
	onPause: (isPanda: boolean, pandaEvent?: IPandaEvent) => void;
	onProgress: (isFinished: boolean, isPanda: boolean, pandaEvent?: IPandaEvent, progressData?: any) => void;
	onEnded: (isFinished: boolean, isPanda: boolean, pandaEvent?: IPandaEvent) => void;
	onReady?: () => void;
	seekTo: (time: number) => void;
}

/**
 * Unified video player component that handles both PandaVideo and ReactPlayer
 * Automatically detects the video type and renders the appropriate player
 */
const VideoPlayer: React.FC<VideoPlayerProps> = ({
	videoUrl,
	playing,
	playerRef,
	startTime,
	onPlay,
	onPause,
	onProgress,
	onEnded,
	onReady,
	seekTo,
}) => {
	const isPandaVideo = videoUrl.includes("pandavideo");

	const handleReady = () => {
		if (startTime > 0) {
			setTimeout(() => {
				seekTo(startTime);
			}, 1000);
		}
		onReady?.();
	};

	return (
		<VideoWrapper role="region" aria-label="Player de vídeo">
			{isPandaVideo ? (
				<PandaVideo
					url={videoUrl}
					onPlay={(e) => onPlay(true, e)}
					onPause={(e) => onPause(true, e)}
					onProgress={(e) => onProgress(false, true, e)}
					onEnded={(e) => onEnded(true, true, e)}
				/>
			) : (
				<ReactPlayer
					controls
					width="100%"
					height="100%"
					src={videoUrl}
					ref={playerRef as any}
					playing={playing}
					onPlay={() => onPlay(false)}
					onPause={() => onPause(false)}
					onProgress={() => {
						// For YouTube, we rely on the auto-save interval instead
						// The progress event doesn't give us useful time data
					}}
					onEnded={() => onEnded(true, false)}
					onReady={handleReady}
					onError={(error: any) => {
						console.error("ReactPlayer Error:", error);
					}}
					style={{
						position: "absolute",
						top: 0,
						left: 0,
					}}
				/>
			)}
		</VideoWrapper>
	);
};

export { VideoPlayer };
